module.exports = __webpack_public_path__ + "dingbeauty-landing/img/Icon_arrowL.0b1bedb1.svg";